import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITagResource, ITagTranslationList } from "../types";

export interface ITagTranslationsQueryParameters {
    tag?: RelationalValue<ITagResource>;
}

export type ITagTranslationsQueryResult = ITagTranslationList;

export const tagTranslationsQuery: IApiQueryFunction<ITagTranslationsQueryParameters> = ({ tag }) => {
    if (!tag) {
        return;
    }

    return {
        method: "GET",
        url: `/tags/${mapRelationalValue(tag)}/translations`,
    };
};

export const useTagTranslationsQuery = createApiQueryHook<ITagTranslationsQueryParameters, ITagTranslationsQueryResult>(
    tagTranslationsQuery,
);
